import { toast, ToastPosition } from "react-toastify";

export function showToast(variation: string, message: string, autoClose = null) {

  const toastDefaults = {
    position: "bottom-right" as ToastPosition,
    autoClose: autoClose || 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  toast[variation](message, toastDefaults);
}